/** Espelha db_vendas.tipo_documento_impressao (impressão automática na separação, expedição e formas de envio). */
export enum TipoDocumentoImpressaoEnum {
    Danfe = 1,
    EtiquetaEnvio = 2,
}
